import saveToBraze from "src/utils/brazeUploader";
import { getSurveyAnswers } from "src/hooks/survey/answers";
import { saveProfile } from "src/utils/redux/slices/userData";
import { ActionHandler } from "..";

/**
 * Creates the shop lead's Iterable profile and sends the shop email capture.
 * Run it only after the survey answers, and so the email, are saved: Growth
 * builds the profile from the saved userData.
 */
export const sendShopOptInResponse: ActionHandler = async ({
  store,
  pageSet,
}) => {
  const state = store.getState();
  const { email } = state.userData;
  if (!email) return;

  // Skip the createdProfile event. It would tag the lead as Healthy Weight.
  await store.dispatch(
    saveProfile({
      email,
      name: getSurveyAnswers(state).firstName,
      skipBrazeEvent: true,
    })
  );

  await saveToBraze({
    event: {
      event_name: "shopOptInResponse",
      event_data: {
        productNameList: state.checkoutOrders.addonsCart ?? [],
        flow: pageSet.id,
        offersAdId: state.upsellAdData.adMetadata?.offersAdId,
      },
    },
  });
};
